import styled, { css } from 'styled-components';
import Colours, { type ColourName } from '/shared/styled/Colours';

interface Props {
  top?: number | string;
  height?: number | string;
  isSplit?: boolean;
  leftOffset?: string;
  backgroundColour?: ColourName;
}

function isBackgroundSplit({ isSplit }: Props) {
  if (isSplit) {
    return css`
      width: 50vw;
    `;
  }
}

function isLeftOffset({ leftOffset }: Props) {
  if (leftOffset) {
    return css`
      left: calc((100% - 100vw) / 2 + ${leftOffset});
    `;
  }
}

function backgroundColourStyle({ backgroundColour }: Props) {
  if (backgroundColour) {
    return css`
      background-color: ${Colours[backgroundColour]};
    `;
  }
}

export default styled.div<Props>`
  top: ${(props) => props.top};
  height: calc(
    100% + ${(props) => (props.height === 0 || props.height === '0' ? '0px' : (props.height ?? '0px'))}
  );
  width: 100vw;
  left: calc((100% - 100vw) / 2);
  position: absolute;

  ${isBackgroundSplit}
  ${isLeftOffset}
  ${backgroundColourStyle}
`;
